// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__sRyNQ","vatRate":"styles_vatRate__fMutT","vatRateLabel":"styles_vatRateLabel__zCDeq","slideInSearchBar":"styles_slideInSearchBar__EbTxP"};